import { render, staticRenderFns } from "./VideoElementUserList.vue?vue&type=template&id=fe8fe5b6&scoped=true&"
import script from "./VideoElementUserList.vue?vue&type=script&lang=js&"
export * from "./VideoElementUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8fe5b6",
  null
  
)

export default component.exports